import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardContent, Typography, Button, Chip } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import deliveryReceiptService from "../../services/deliveryReceiptService";
import EmptyState from "../../components/common/EmptyState";
import SkeletonLoader from "../../components/common/SkeletonLoader";

const RiderMyDeliveries = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [receipts, setReceipts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        deliveryReceiptService
            .getMine()
            .then(({ data }) => setReceipts(data.data.receipts || []))
            .catch(() => enqueueSnackbar("Failed to load your deliveries", { variant: "error" }))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <SkeletonLoader rows={4} />;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="h6" fontWeight={700}>
                My Deliveries ({receipts.length})
            </Typography>

            {receipts.length === 0 ? (
                <EmptyState icon="🚚" title="No claimed deliveries" description="Claim a delivery from the Available tab to get started." />
            ) : (
                receipts.map((r) => (
                    <Card key={r._id}>
                        <CardContent>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
                                <Box>
                                    <Typography fontWeight={700}>
                                        {r.customer?.firstName} {r.customer?.lastName}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {r.receiptNumber}
                                    </Typography>
                                </Box>
                                <Chip label={`${r.items?.length || 0} pkg`} size="small" />
                            </Box>
                            <Typography variant="body2" color="text.secondary" mb={2}>
                                {r.deliveryAddress || "No address on file"}
                            </Typography>
                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={<CheckCircle />}
                                onClick={() => navigate(`/rider/deliver/${r.receiptNumber}`)}
                            >
                                Complete Delivery
                            </Button>
                        </CardContent>
                    </Card>
                ))
            )}
        </Box>
    );
};

export default RiderMyDeliveries;
